export default "__VITE_ASSET__d745d42b__"